import React from 'react';
export function SocialSection() {
  return <section className="bg-white py-20 overflow-hidden" data-id="element-150">
      <div className="text-center mb-12 px-4" data-id="element-151">
        <h2 className="text-3xl md:text-4xl text-[#1A1A1A] leading-tight" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-152">
          Follow the Glow ✦ @raisethebarmedspa
        </h2>
      </div>

      {/* Marquee Banner */}
      <div className="bg-[#1A1A1A] py-3 mb-12 flex overflow-hidden whitespace-nowrap relative" data-id="element-153">
        <div className="animate-[marquee_20s_linear_infinite] flex items-center" data-id="element-154">
          {[...Array(10)].map((_, i) => <span key={i} className="text-[#C8A84E] text-sm font-semibold tracking-widest uppercase mx-4" style={{
          fontFamily: "'Montserrat', sans-serif"
        }} data-id="element-155">
              ● tag us #raisethebarbabes ● Follow us on Instagram
            </span>)}
        </div>
      </div>

      {/* Instagram Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12" data-id="element-156">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-157">
          {[{
          src: 'https://cdn.magicpatterns.com/uploads/bMUWyLZXruqww3YZ3vu6y8/raise_the_bar_june_2024-55.jpg',
          alt: 'Team member portrait'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/kTrgugudR5gK3bnFEpnrME/pexels-nataliya-vaitkevich-5128220.jpg',
          alt: 'Lash extension treatment'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/szoqGg4M4nfdQWirC3aPbD/raise_the_bar_june_2024-130.jpg',
          alt: 'Team members with skincare products'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/5FKEZYVQWEXR8ZmrCTSbdf/raise_the_bar_june_2024-186.jpg',
          alt: 'ZO Skin Health serum product'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/22VWnkh4kgxNoszv248YPd/raise_the_bar_june_2024-14.jpg',
          alt: 'Team member portrait'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/8RiW2WPmcDJU7sEUQhTcLP/pexels-sveta-glodan-5881082.jpg',
          alt: 'Lash and brow tools flatlay'
        }].map((item, i) => <div key={i} className="bg-gray-200 aspect-square rounded-lg overflow-hidden relative group cursor-pointer" data-id="element-158">
              {item && <img src={item.src} alt={item.alt} className="w-full h-full object-cover" data-id="element-159" />}
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-160">
                <span className="text-white font-semibold" data-id="element-161">
                  View on Instagram
                </span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="text-center px-4" data-id="element-162">
        <a href="#instagram" className="inline-flex items-center justify-center bg-[#1A1A1A] border-2 border-[#C8A84E] text-white hover:bg-[#C8A84E] hover:text-black px-8 py-4 rounded-full font-semibold transition-all duration-300 min-h-[48px]" style={{
        fontFamily: "'Montserrat', sans-serif"
      }} data-id="element-163">
          Follow Us on Instagram
        </a>
      </div>

      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `
    }} data-id="element-164" />
    </section>;
}